import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-objetivo-venda-filtro',
  templateUrl: './objetivo-venda-filtro.component.html',
  styleUrls: ['./objetivo-venda-filtro.component.css']
})
export class ObjetivoVendaFiltroComponent implements OnInit {

  @Input() filtros: any;

  constructor() { }

  ngOnInit() {
  }
}
